@import "@/scss/use-bootstrap-mixins.scss";

.sizeLabel {
  background-color: #535353;
  border-radius: 20px;
  padding-left: 1px;
  display: flex;
  align-items: center;
  padding: 2px 6px;
  height: 20px;
  font-size: 10px !important;
  font-weight: 600;
  color: #fff !important;
}

.label {
  .type_0 {
    span {
      font-size: 27px !important;
      font-weight: 600 !important;
      line-height: 25px !important;
    }
  }

  .type_1 {
    .top {
      display: flex;
      align-items: center;
      gap: 10px;

      .area {
        font-size: 36px !important;
        font-weight: 600 !important;
        line-height: 38px !important;
      }
    }
  }

  .type_2 {
    .dimensions {
      font-size: 36px !important;
      font-weight: 600 !important;
      line-height: 38px !important;
    }

    .bottom {
      display: flex;
      align-items: center;
      gap: 6px;
    }
  }
}
